
import googleIcon from '../../assets/img/icons/google-icon.png';
import { useGoogleLogin } from '@react-oauth/google';

function GoogleButton({ loginCallback, label, onLoginStart, onLoginCancel, onLoginFailure }) {
    const login = useGoogleLogin({
        onSuccess: tokenResponse => {
            console.log(tokenResponse);
            loginCallback(tokenResponse);
        },
        onError: error => {
            console.log(error);
            onLoginFailure(error);
        },
        onNonOAuthError: error => {
            console.log(error);
            onLoginCancel(error);
        },
        flow: 'auth-code'
    });

    return <button className='flex aic' style={{ border: '1px solid #0a211f1a', width: '100%', fontSize: 14, borderRadius: 128, fontWeight: 500 }} onClick={() => { onLoginStart(); login(); }}>
        <img src={googleIcon} alt="google icon" style={{ height: 16, width: 16, margin: '0 10px' }} />
        <div>
            {label ? label : 'Continue with Google'}
        </div>
    </button>
}

export default GoogleButton;